import Icon from '../components/Icon.vue'

Icon.register({
  passport: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M129.6 176c5.3-31.2 25.6-57.2 53.3-70.4-7.7 19.1-12.7 43.4-14.2 70.4h-39.1zM129.6 208h39.1c1.5 27 6.5 51.3 14.2 70.4-27.7-13.2-48-39.2-53.3-70.4zM224 286.7c-7.7-7.5-20.8-34.4-23.4-78.7h46.9c-2.7 44.3-15.7 71.2-23.4 78.7zM200.6 176c2.7-44.3 15.7-71.2 23.4-78.7 7.7 7.5 20.8 34.4 23.4 78.7h-46.9zM265.1 278.4c7.7-19.1 12.7-43.4 14.2-70.4h39.1c-5.3 31.2-25.6 57.2-53.3 70.4zM416 0c17.7 0 32 14.3 32 32v448c0 17.7-14.3 32-32 32h-352c-35.3 0-64-28.7-64-64v-384c0-35.3 28.7-64 64-64h352zM336 416c8.8 0 16-7.2 16-16s-7.2-16-16-16h-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h224zM224 320c70.7 0 128-57.3 128-128s-57.3-128-128-128-128 57.3-128 128 57.3 128 128 128zM265.1 105.6c27.7 13.2 48 39.2 53.3 70.4h-39.1c-1.5-27-6.5-51.3-14.2-70.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/passport.js
// module id = 1613
// module chunks = 0